import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsContainer from "@/components/CardsContainer";
import CardsList from "@/components/CardsList";
import CardsTable from "@/components/CardsTable";

import {StaffAPI} from "@/api/staff";

import AddIcon from "@mui/icons-material/Add";

import {ERROR_OPERATION} from "@/utils/constants";

// import "./index.scss";

function StaffUnitsPage(props) {
	const {handleNotification} = props;
	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);
	const [units, setUnits] = useState([]);

	const getUnits = async () => {
		try {
			const response = await StaffAPI.unitsList();
			setUnits(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getUnits();
	}, []);

	const listConfiguration = {
		data: units,
		onClick: (unit) => navigate("/settings/staff-units/" + unit.id),
		title: (unit) => unit.name,
	};

	const columns = [{label: "Nome", key: "name", align: "start"}];

	const mainActions = [
		{
			icon: <AddIcon />,
			onClick: () => navigate("/settings/staff-units/new"),
			color: "info",
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs actions={<MainActions actions={mainActions} />} />
			<CardsContainer
				tableComponent={
					<CardsTable
						breadcrumbs
						configurationColumns={columns}
						data={units}
						fullWidth
						handleClick={(item) => {
							navigate("/settings/staff-units/" + item.id);
						}}
						defaultSortedField="name"
					/>
				}
				listComponent={
					<CardsList
						type="users"
						breadcrumbs
						listConfiguration={listConfiguration}
						defaultSortedField="name"
					/>
				}
			/>
		</Page>
	);
}

export default StaffUnitsPage;
